import React, { useEffect, useState } from 'react';

function AlertaSistemas() {
  const [filteredData, setFilteredData] = useState([]);
  const [showAdminAlert, setShowAdminAlert] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const key = 'AIzaSyADukn7uRD52osQoHWiOwvHyretAb4B0RE';
      const idSheet = '1dBfhPoTuo4RBcmtoa3JVLoomBEXmvT3-wZkefMzzZTw';
      const range = 'cabaprop!A2:D';
      const sheetV4Uri = `https://sheets.googleapis.com/v4/spreadsheets/${idSheet}/values/${range}?key=${key}`;

      try {
        const response = await fetch(sheetV4Uri);
        const data = await response.json();

        const filterActive = data.values.filter(item => item[3] === '1');
        setFilteredData(filterActive);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Verifica si el path de la URL es igual a "cabaprop.ar/admin"
    if (
      window.location.href.includes('cabaprop.ar') ||
      window.location.href.includes('localhost:3000')
    ) {
      setShowAdminAlert(true);
    }
  }, []);

  const alertBarStyle = backgroundColor => ({
    top: 0,
    left: 0,
    width: '100%',
    backgroundColor,
    color: 'white' /* Cambia el color de texto según tus necesidades */,
    padding: '10px',
    textAlign: 'center',
    zIndex: 1000 /* Asegura que la barra esté por encima del contenido */,
    boxShadow:
      '0px 2px 5px rgba(0, 0, 0, 0.2)' /* Agrega una sombra si lo deseas */
  });

  return (
    <div>
      {/* Mostrar la alerta para "/admin" */}
      {showAdminAlert && (
        <div
          className="admin-alert mb-2"
          style={alertBarStyle('red')}
          role="alert"
        >
          Este es un entorno de prueba, para ingresar al sitio de administración
          de Cabaprop, hacé click{' '}
          <a href="https://cabaprop.com.ar/admin">aquí</a>
        </div>
      )}

      {/* Render your filtered data here */}
      {filteredData.map((item, index) => (
        <div key={index}>
          {/* Display data for each item */}
          <div className="alert" style={alertBarStyle(item[2])} role="alert">
            <b>{item[0]}</b> {item[1]}
          </div>
        </div>
      ))}
    </div>
  );
}

export default AlertaSistemas;
